import React from 'react';
import {Button, Card, Col, Row, Tabs, Input} from "antd";
import SearchBox from "./SearchBox";
import {ContactsView} from "./ContactsView";
import {getUsers} from "../../actions/users";
import ContactListSelection from "./ContactListSelection";
const { TabPane } = Tabs;
const { TextArea } = Input;

class ContactSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      emailInput: ''
    }
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  handleEmailInput = ({ target: { value }}) => {
    this.setState({
      emailInput: value
    })
  };

  handleInvite = (contact) => {
    const { onInvite } = this.props;
    if (onInvite) onInvite(contact);
  };

  // FName LName <Email>
  // FName LName Email
  // Name <Email>
  // Name Email
  // <Email>
  // Email
  static emailPatterns = [
    /^\S+\s+\S+\s+<(\S+@\S+)>$/,
    /^\S+\s+\S+\s+(\S+@\S+)$/,
    /^\S+\s+<(\S+@\S+)>$/,
    /^\S+\s+(\S+@\S+)$/,
    /^<(\S+@\S+)>$/,
    /^(\S+@\S+)$/,
  ];

  parseEmails = (emailInput) => {
    let lines = emailInput.split('\n');
    let emails = [];
    const patterns = ContactSearch.emailPatterns;
    lines.forEach(line => {
      for (let pattern of patterns) {
        let match = line.match(pattern);
        if (match) {
          emails.push(match[1]);
          break;
        }
      }
    });
    return emails;
  };

  handleEmailInvite = () => {
    const { emailInput } = this.state;
    const { onEmailInvite } = this.props;
    if (onEmailInvite) {
      let emails = this.parseEmails(emailInput);
      onEmailInvite(emails);
    }
  };

  render() {
    const { searchState, searchResults, onBack, onSearch, disableEmail } = this.props;
    const { extras, onContactListInvite } = this.props;  // shape of this is (handleInvite) => (contact) => React node
    const { emailInput } = this.state;
    return (
      <div>
        <Card
          title='Add Contacts'
          extra={<Button icon='caret-left' onClick={onBack}>Back</Button>}
        >
          <Tabs>
            <TabPane
              tab='Contact Search'
              key='1'
            >
              <SearchBox
                placeholder="name, company, email, phone, city, state"
                onChange={onSearch}
                className='contact-search control-search'
                // style={{ width: 400 }}
                interactive
              />
              {
                (searchResults.length === 0 && searchState === 'complete')
                  ? <div><div className='contacts-header'/></div>
                  : <ContactsView
                    contacts={searchResults}
                    extras={extras(this.handleInvite)}
                    loader={({user: {resource: {id}}}, dispatch) => dispatch(getUsers(id))}
                  />
              }
            </TabPane>
            { !disableEmail &&
              <TabPane
                tab='Mass Email Invite'
                key='2'
                className='mass-email-invite'
                disable={disableEmail}
              >
                <h2>Mass Email Invite</h2>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col span={6}>
                    <p>Enter a list of name/email addresses to invite.</p>
                    <p>Accepted Formats:</p>
                    <ul>
                      <li>FName LName {'<'}Email{'>'}</li>
                      <li>FName LName Email</li>
                      <li>Name {'<'}Email{'>'}</li>
                      <li>Name Email</li>
                      <li>{'<'}Email{'>'}</li>
                      <li>Email</li>
                    </ul>
                  </Col>
                  <Col span={18}>
                    <TextArea onChange={this.handleEmailInput} value={emailInput}/>
                    <Button className='high-contrast' onClick={this.handleEmailInvite}>Invite</Button>
                  </Col>
                </Row>
              </TabPane>
            }
            { !disableEmail && onContactListInvite &&
              <TabPane
                tab='Contact Lists'
                key='3'
                className='contact-list-invite'
              >
                <h2>Contact Lists</h2>
                <ContactListSelection onInvite={onContactListInvite}/>
              </TabPane>
            }
          </Tabs>
        </Card>

      </div>
    );
  }
}

ContactSearch.propTypes = {};

export default ContactSearch;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ContactSearch.js